import logo from '../svg/logo.svg';
import { Link } from "react-router-dom";
import './styles/Header.scss';
import { 
  ROUTE_HOME, 
  ROUTE_ABOUT, 
  ROUTE_TOKEN_PAGE, 
  ROUTE_TEAM_PAGE, 
  API_URL
} from '../../App';
import { ReactComponent as Logo2 } from '../svg/logo2.svg';
import { ReactComponent as Hamburger } from '../svg/hamburger.svg';
import { ReactComponent as CloseIcon } from '../svg/close.svg';
import { ReactComponent as ArrowDown } from '../svg/arrowDown.svg';
import Button from './Button';
import { useCallback, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom'
import useFetch from '../hooks/useFetch';
import Spinner from './Spinner';


function Header(props) {
  const {
    pages = [],
  } = props;
  const location = useLocation();

  const [theme, setTheme] = useState('');
  const [isShown, setIsShown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const { error, loading, data } = useFetch(API_URL + '/dropdown-docs');

  function isLight() {
    if (location.pathname === '/token') {
      return setTheme('light');
    }
    if (theme !== '') {
      setTheme('');
    }
  }

  const drop = useCallback(() => {
    setIsShown(true);
  }, [])

  const retract = useCallback(() => {
    setIsShown(false);
  }, [])

  useEffect(() => {
    isLight();
    if (menuOpen) {
      setMenuOpen(false);
    }
  }, [location]);

  const permanentPages = [  
  {
    route: ROUTE_ABOUT,
    Title: 'About',
  }, 
  {
    route: ROUTE_TOKEN_PAGE,
    Title: 'PBX Token',
  }, 
  {
    route: ROUTE_TEAM_PAGE,
    Title: 'Team',
  }]

  const finalPages = pages.length !== 0 ? permanentPages.concat(pages.map(page => page.attributes)) : permanentPages;

  return (
    <header className="header">
      <div className="headerContainer">
        <div className="headerAll">
          <Link to={ROUTE_HOME} className="headerAllLogo">
            <img src={logo} alt="Logo" />
            <Logo2 className={"headerLogo2 " + theme} />
          </Link>
          <div className="headerAllLinks">
            {finalPages.map(page => {
              const isCurrentPage = location.pathname.includes(page.route) ? 'current' : '';
              
              return ( 
                <Link className={"headerLink menu1 " + theme + ' ' + isCurrentPage} to={page.route}>{page.Title}</Link>
              )
            })}
            <div className={'dropdownBox menu1 ' + theme} onMouseEnter={drop} onMouseLeave={retract}>
              Docs
              {isShown && data && (
                <div className={"dropdown " + theme}>
                  {data.data.map(docs => {
                    return (
                      <a className={"dropdownItem " + theme} href={docs.attributes.Link} target="_blank">{docs.attributes.Name}</a>
                    )
                  })}
                </div>
              )}
               <ArrowDown className={'arrow' + (isShown ? 'Down' : 'Up')}/>
            </div>
          </div>
         {/*  <Button>SIGN UP</Button> */}
          <div className="hamburgerIconContainer" >
            <Hamburger className='hamburgerIcon' onClick={() => setMenuOpen(true)} />
          </div>
        </div>
      </div>
      <div className="headerLine">
        <div className="headerLineMain"></div>
      </div>

      {menuOpen && 
      <div className="mobileMenu">
        <div className="mobileMenuHeader">
          <Link onClick={() => setMenuOpen(false)} to={ROUTE_HOME} className="headerAllLogo logoWhite">
            <img src={logo} alt="Logo" />
            <Logo2 className='headerLogo2' />
          </Link>
          <CloseIcon className="closeIcon" onClick={() => setMenuOpen(false)} />
        </div>
        {finalPages.map(page => {
              return (
                <Link className={"menu1 mobileLink"} to={page.route}>{page.Title}</Link>
              )
            })}
        {loading &&
        <div className='mobileMenuSpinnerContainer'>
          <Spinner />
        </div>
         }
        {data && data?.data.map(docs => {
          return (
            <a className="menu1 mobileLink" href={docs.attributes.Link} target="_blank">{docs.attributes.Name}</a>
          )
        })}
      {/*   <div className="mobileButton">
          <Button >SIGN UP</Button>
        </div> */}
      </div>}
    </header>
  )
}

export default Header;